import { useState } from 'react'
import { apiWrapper } from './dataHookUtils'
import useFetch from '../hooks/useFetch'
//import useMe from '../hooks/useMe'
import useSnackbar from '../hooks/useSnackbar'

export default () => {
  const fetch = useFetch()

  const [isLoading, setIsLoading] = useState()
  //const [implementation, setImplementation] = useState()
  const [userAccount, setUserAccount] = useState()
  const [userAccounts, setUserAccounts] = useState()

  //const { userId } = useMe()
  const { newMessage } = useSnackbar()

  /*const fetchImplementation = async () => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/implementation?userId=${userId}`,
        options: {
          method: 'GET'
        }
      });
      setImplementation(result)
      return result
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error retrieving user implementation', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }*/

  const fetchUserAccount = async (userId) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/user?userId=${userId}`,
        options: {
          method: 'GET'
        }
      });
      const record = result?.[0]
      setUserAccount(record)
      return record
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error retrieving user', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUserAccounts = async (accountId, implementationId, includePastImplementations) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/users?accountId=${accountId}&implementationId=${implementationId}&includePastImplementations=${includePastImplementations}`,
        options: {
          method: 'GET'
        }
      });
      setUserAccounts(result)
      return result
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error retrieving users', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const updateUserAccount = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/user/update`,
        options: {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: [data] })
        }
      });
      return result
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error updating user account', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const postUserHeadshot = async (file) => {
    try {
      setIsLoading(true)

      const formData = new FormData();
      formData.append('file', file);

      const result = await apiWrapper({
        fetch,
        url: `accounts/headshot`,
        options: {
          method: 'POST',
          body: formData
        }
      });

      return result
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error updating headshot', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    //implementation,
    //fetchImplementation,
    userAccount,
    fetchUserAccount,
    userAccounts,
    fetchUserAccounts,
    updateUserAccount,
    postUserHeadshot
  }
}